export const customFetch = {
  get: async (url: string, headers: any = {}) => {
    return fetch(url, {
      method: 'GET',
      headers: {
        ...headers,
      },
    })
      .then(async (res) => {
        const data = await res.json();
        return { statusCode: res.status, data };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  post: async (url: string, data: unknown, headers: any = {}) => {
    return fetch(url, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        return { statusCode: res.status, data: await res.json() };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  postformdata: async (url: string, data: FormData, headers: any = {}) => {
    return fetch(url, {
      method: 'POST',
      headers: {
        ...headers,
        // ⚠️ Ne pas fixer 'Content-Type', il sera ajouté automatiquement par le navigateur
      },
      body: data, // ✅ Envoie FormData tel quel
    })
      .then(async (res) => {
        return {
          statusCode: res.status,
          data: await res.json().catch(() => ({})), // sécurité en cas de non-JSON
        };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  putformdata: async (url: string, data: FormData, headers: any = {}) => {
    return fetch(url, {
      method: 'PUT',
      headers: {
        ...headers,
        // ⚠️ Ne pas fixer 'Content-Type', il sera ajouté automatiquement par le navigateur
      },
      body: data,
    })
      .then(async (res) => {
        return { statusCode: res.status, data: await res.json() };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  put: async (url: string, data: unknown) => {
    return fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        return { statusCode: res.status, data: await res.json() };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  patch: async (url: string, data: unknown) => {
    return fetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        return { statusCode: res.status, data: await res.json() };
      })
      .catch((err) => {
        return { statusCode: 500, data: err.message };
      });
  },

  delete: async (url: string) => {
    return fetch(url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => res.json());
  },

  deletenon: (url: string) => {
    return fetch(url, {
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    }).then();
  },
};
